import { useRef, useState } from "react";
import { Play } from "lucide-react";

// Elegant video testimonial card: poster frame + gold play button -> native controls on play.
export default function VideoTestimonial({ item, testId }) {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [error, setError] = useState(false);

  const handlePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    setError(false);
    setPlaying(true);
    const p = v.play();
    if (p && typeof p.catch === "function") {
      p.catch(() => {
        setPlaying(false);
        setError(true);
      });
    }
  };

  return (
    <div className="group" data-testid={testId}>
      <div className="relative overflow-hidden rounded-sm bg-night aspect-[4/5]">
        <video
          ref={videoRef}
          src={item.src}
          poster={item.poster}
          preload="metadata"
          playsInline
          controls={playing}
          onError={() => { setError(true); setPlaying(false); }}
          onEnded={() => setPlaying(false)}
          className="w-full h-full object-cover"
        />
        {!playing && (
          <button
            type="button"
            onClick={handlePlay}
            aria-label={`Play ${item.brand} testimonial`}
            data-testid={`${testId}-play`}
            className="absolute inset-0 flex items-center justify-center bg-gradient-to-t from-black/50 via-black/10 to-black/30 transition-colors duration-300 hover:from-black/60"
          >
            <span className="flex items-center justify-center w-20 h-20 rounded-full border border-ivory/50 bg-ivory/10 backdrop-blur-sm transition-all duration-300 group-hover:bg-gold group-hover:border-gold">
              <Play className="w-7 h-7 text-ivory ml-1" strokeWidth={1.25} fill="currentColor" />
            </span>
          </button>
        )}
        {error && (
          <div className="absolute bottom-4 left-4 right-4 text-center">
            <p className="font-sans text-xs text-ivory/70">
              Trouble playing here? Open in Chrome or Safari to watch the full story.
            </p>
          </div>
        )}
      </div>
      <div className="mt-6">
        <h3 className="font-serif text-3xl md:text-4xl text-charcoal font-light">{item.brand}</h3>
        <p className="mt-2 font-sans text-sm text-charcoal/70">
          {item.author}, {item.role}
        </p>
        <p className="mt-1 font-sans text-xs uppercase tracking-[0.18em] text-gold">{item.context}</p>
      </div>
    </div>
  );
}
